<div class="app-l-page-wrap">
    <page-loader *ngIf="!isLoaded"></page-loader>
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" (click)="goBack()">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                [attr.aria-label]="'common.back' | translate">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul>
                <li
                    translate
                    *ngIf="loggedInUser.userType === 'professional'"
                    tabindex="0"
                    [attr.aria-label]="'clientList.userDashboard' | translate"
                    (click)="goBack()">
                    clientList.userDashboard
                </li>
                <li
                    translate
                    *ngIf="loggedInUser.userType === 'user'"
                    tabindex="0"
                    [attr.aria-label]="
                        'assessmentTypeListing.tabTitle' | translate
                    "
                    routerLink="/app/assessments/listing">
                    assessmentTypeListing.tabTitle
                </li>
                <li class="app-l-current-page" translate>
                    {{ 'assessments.' + typeAssessment + '.title' }}
                </li>
            </ul>
        </div>
    </div>
    <div class="app-dm-das-assessment-list" *ngIf="isLoaded">
        <div class="app-l-summary__base">
            <div class="app-l-result-summary">
                <div class="app-l-result__card">
                    <div class="app-l-result__card-header">
                        <div class="app-l-result__card-header-left">
                            <h3
                                [attr.aria-label]="
                                    'das.resultsSummary' | translate
                                "
                                class="app-c-heading--h3"
                                translate>
                                das.resultsSummary
                            </h3>
                            <div *ngIf="user.userType === 'user'" class="row">
                                <p
                                    class="recent-tabs-disclaimer"
                                    id="disclaimerHeading">
                                    <ng-container *ngIf="!showConnect()">
                                        <span
                                            [innerHTML]="
                                                'dynamicAssessment.disclaimerDesc1.0'
                                                    | translate
                                            "></span>
                                        <emergency-contact
                                            [showAsButton]="true"
                                            [isTemplateView]="true"
                                            [templateType]="'assessmentDisclaimer'"
                                            [cssClass]="'assessmentDisclaimer'"
                                            [user]="user">
                                        </emergency-contact>
                                        <span
                                            [innerHTML]="
                                                'dynamicAssessment.disclaimerDesc1.1'
                                                    | translate
                                            "></span>
                                    </ng-container>

                                    <ng-container *ngIf="showConnect()">
                                        {{
                                            'dynamicAssessment.disclaimerDesc2.0'
                                                | translate
                                        }}
                                        <emergency-contact
                                            [showAsButton]="true"
                                            [isTemplateView]="true"
                                            [templateType]="'assessmentDisclaimer'"
                                            [cssClass]="'assessmentDisclaimer'"
                                            [user]="user">
                                        </emergency-contact>
                                        <span
                                            [innerHTML]="
                                                'dynamicAssessment.disclaimerDesc2.1'
                                                    | translate
                                            "></span>
                                        <a
                                            role="button"
                                            class="course-link-title"
                                            tabindex="0"
                                            href="https://welltrack-connect.com/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            translate>
                                            theory.welltrackConnect
                                        </a>
                                    </ng-container>
                                </p>
                            </div>
                        </div>
                        <div
                            class="app-l-result__card-header-right"
                            *ngIf="
                                loggedInUser.userType === 'user' ||
                                (loggedInUser.userType != 'user' && !syncUserId)
                            ">
                            <button
                                *ngIf="
                                    typeAssessment !== 'mentalwellbeing' &&
                                    typeAssessment !== 'crafft'
                                "
                                tabindex="0"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                [attr.aria-label]="
                                    'das.startAssessment' | translate
                                "
                                [routerLink]="
                                    '/app/assessments/' +
                                    typeAssessment +
                                    '/new'
                                "
                                translate>
                                das.startAssessment
                            </button>
                            <button
                                *ngIf="typeAssessment === 'crafft'"
                                tabindex="0"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                [attr.aria-label]="
                                    'das.startAssessment' | translate
                                "
                                [routerLink]="
                                    '/app/crafft-assessments/' +
                                    typeAssessment +
                                    '/new'
                                "
                                translate>
                                das.startAssessment
                            </button>
                            <button
                                *ngIf="typeAssessment === 'mentalwellbeing'"
                                tabindex="0"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                [attr.aria-label]="
                                    'das.startAssessment' | translate
                                "
                                [routerLink]="
                                    '/app/wellbeing-assessments/' +
                                    typeAssessment +
                                    '/new'
                                "
                                translate>
                                das.startAssessment
                            </button>
                        </div>
                    </div>

                    <div class="app-l-result__card-body">
                        <div class="app-l-result-summary__control">
                            <div class="app-l-result-summary__tab">
                                <div class="app-c-tab--primary">
                                    <nav class="mat-mdc-tab-nav-bar mat-tab-nav-bar">
                                        <div class="mat-mdc-tab-link-container">
                                            <div class="mat-mdc-tab-links">
                                                <a
                                                    tabindex="0"
                                                    class="mat-mdc-tab-link mdc-tab"
                                                    [class.mdc-tab--active]="activeLink == dateFilterOptions[0].key"
                                                    (click)="
                                                        onSelectFilterData(
                                                            dateFilterOptions[0]
                                                        )
                                                    "
                                                    (keypress)="
                                                        onSelectFilterData(
                                                            dateFilterOptions[0]
                                                        )
                                                    ">
                                                    <span class="mdc-tab__content">
                                                        <span class="mdc-tab__text-label">{{
                                                            'das.dateFilter.' +
                                                                dateFilterOptions[0].key
                                                                | translate
                                                        }}</span>
                                                    </span>
                                                </a>
                                                <a
                                                    tabindex="0"
                                                    class="mat-mdc-tab-link mdc-tab"
                                                    [class.mdc-tab--active]="activeLink == dateFilterOptions[1].key"
                                                    (click)="
                                                        onSelectFilterData(
                                                            dateFilterOptions[1]
                                                        )
                                                    "
                                                    (keypress)="
                                                        onSelectFilterData(
                                                            dateFilterOptions[1]
                                                        )
                                                    ">
                                                    <span class="mdc-tab__content">
                                                        <span class="mdc-tab__text-label">{{
                                                            'das.dateFilter.' +
                                                                dateFilterOptions[1].key
                                                                | translate
                                                        }}</span>
                                                    </span>
                                                </a>
                                                <a
                                                    tabindex="0"
                                                    class="mat-mdc-tab-link mdc-tab"
                                                    [class.mdc-tab--active]="activeLink == dateFilterOptions[2].key"
                                                    (click)="
                                                        onSelectFilterData(
                                                            dateFilterOptions[2]
                                                        )
                                                    "
                                                    (keypress)="
                                                        onSelectFilterData(
                                                            dateFilterOptions[2]
                                                        )
                                                    ">
                                                    <span class="mdc-tab__content">
                                                        <span class="mdc-tab__text-label">{{
                                                            'das.dateFilter.' +
                                                                dateFilterOptions[2].key
                                                                | translate
                                                        }}</span>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div class="chart-container">
                            <canvas
                                #dasAssessmentChart
                                id="dasAssessmentChart"></canvas>
                        </div>
                        <div class="app-l-chart__legends">
                            <button
                                *ngIf="typeAssessment === 'dass'"
                                [ngClass]="{
                                    active: selectedChartLegend === 'all',
                                }"
                                [attr.aria-label]="'das.all' | translate"
                                (click)="selectLegend('all')"
                                (keypress)="selectLegend('all')"
                                translate>
                                das.all
                            </button>
                            <button
                                class="app-l-legend__depression"
                                *ngIf="
                                    typeAssessment === 'dass' ||
                                    typeAssessment === 'depression'
                                "
                                [attr.aria-label]="'das.depression' | translate"
                                [ngClass]="{
                                    active:
                                        selectedChartLegend === 'depression',
                                }"
                                (click)="selectLegend('depression')"
                                (keypress)="selectLegend('depression')"
                                translate>
                                das.depression
                            </button>
                            <button
                                class="app-l-legend__anxity"
                                *ngIf="
                                    typeAssessment === 'dass' ||
                                    typeAssessment === 'anxiety'
                                "
                                [attr.aria-label]="'das.anxiety' | translate"
                                [ngClass]="{
                                    active: selectedChartLegend === 'anxiety',
                                }"
                                (click)="selectLegend('anxiety')"
                                (keypress)="selectLegend('anxiety')"
                                translate>
                                das.anxiety
                            </button>
                            <button
                                class="app-l-legend__stress"
                                *ngIf="typeAssessment === 'dass'"
                                [ngClass]="{
                                    active: selectedChartLegend === 'stress',
                                }"
                                [attr.aria-label]="'das.stress' | translate"
                                (click)="selectLegend('stress')"
                                (keypress)="selectLegend('stress')"
                                translate>
                                das.stress
                            </button>
                            <button
                                class="app-l-legend__resilience"
                                *ngIf="typeAssessment === 'resilience'"
                                [ngClass]="{
                                    actve: selectedChartLegend === 'resilience',
                                }"
                                [attr.aria-label]="
                                    'assessmentTranslation.resilience'
                                        | translate
                                "
                                (click)="selectLegend('resilience')"
                                (keypress)="selectLegend('resilience')"
                                translate>
                                {{ assessmentTranslation.resilience }}
                            </button>
                            <button
                                class="app-l-legend__alcoholuse"
                                *ngIf="typeAssessment === 'alcoholuse'"
                                [ngClass]="{
                                    actve: selectedChartLegend === 'alcoholuse',
                                }"
                                [attr.aria-label]="
                                    'assessmentTranslation.alcoholuse'
                                        | translate
                                "
                                (click)="selectLegend('alcoholuse')"
                                (keypress)="selectLegend('alcoholuse')"
                                translate>
                                {{ assessmentTranslation.alcoholuse }}
                            </button>
                            <button
                                class="app-l-legend__crafft"
                                *ngIf="typeAssessment === 'crafft'"
                                [ngClass]="{
                                    actve: selectedChartLegend === 'crafft',
                                }"
                                (click)="selectLegend('crafft')"
                                translate>
                                {{ assessmentTranslation.crafft }}
                            </button>
                            <button
                                class="app-l-legend__stress"
                                *ngIf="typeAssessment === 'mentalwellbeing'"
                                [ngClass]="{
                                    actve:
                                        selectedChartLegend ===
                                        'mentalwellbeing',
                                }"
                                [attr.aria-label]="
                                    'assessmentTranslation.mentalwellbeing'
                                        | translate
                                "
                                (click)="selectLegend('mentalwellbeing')"
                                (keypress)="selectLegend('mentalwellbeing')"
                                translate>
                                {{ assessmentTranslation.mentalwellbeing }}
                            </button>
                        </div>
                        <div
                            class="current-goal-conatiner"
                            *ngIf="
                                typeAssessment == 'mentalwellbeing' &&
                                this.myCurrentGoal
                            ">
                            <div class="content-section" translate>
                                <div>
                                    <h5 class="app-c-heading--h3" translate>
                                        dynamicAssessment.mentalwellbeing.myCurrentGoal
                                    </h5>

                                    <span
                                        class="recent-tabs-disclaimer"
                                        [translate]="myCurrentGoal"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="app-l-assessment-results">
                <div class="app-l-result__card">
                    <div
                        class="app-l-result__card-header"
                        *ngIf="typeAssessment === 'dass'; else otherAssessment">
                        <div class="app-l-result__card-header-left">
                            <h3 class="app-c-heading--h3" translate>
                                {{ 'das.dasAssessmentResults' }}
                            </h3>
                        </div>
                        <div class="app-l-result__card-header-right">
                            <button
                                *ngIf="
                                    gethelpbuttondas &&
                                    (contactGroupTelephone ||
                                        contactGroupTextMsgNumber)
                                "
                                (click)="
                                    onCallContact(
                                        $event,
                                        organization.contactGroup
                                    )
                                "
                                (keypress)="
                                    onCallContact(
                                        $event,
                                        organization.contactGroup
                                    )
                                "
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve">
                                <svg-icon icon="get-help"></svg-icon>
                                <span translate>{{
                                    'contact.getHelpNow' | translate
                                }}</span>
                            </button>
                            <button
                                *ngIf="gethelpbuttondas && showOther"
                                (click)="onHotline($event)"
                                (keypress)="onHotline($event)"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve">
                                <svg-icon icon="get-help"></svg-icon>
                                <span translate>{{
                                    'contact.getHelpNow' | translate
                                }}</span>
                            </button>
                        </div>
                    </div>

                    <div
                        class="app-l-result__card-header"
                        *ngIf="typeAssessment != 'dass'">
                        <div class="app-l-result__card-header-left">
                            <h3 class="app-c-heading--h3" translate>
                                {{
                                    'assessments.' +
                                        typeAssessment +
                                        '.titleResult'
                                        | translate: { value: typeAssessment }
                                }}
                            </h3>
                        </div>
                        <div class="app-l-result__card-header-right">
                            <button
                                tabindex="0"
                                *ngIf="
                                    gethelpbutton &&
                                    (contactGroupTelephone ||
                                        contactGroupTextMsgNumber)
                                "
                                (click)="
                                    onCallContact(
                                        $event,
                                        organization.contactGroup
                                    )
                                "
                                (keypress)="
                                    onCallContact(
                                        $event,
                                        organization.contactGroup
                                    )
                                "
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve">
                                <svg-icon icon="get-help"></svg-icon>
                                <span translate>{{
                                    'contact.getHelpNow' | translate
                                }}</span>
                            </button>
                            <button
                                tabindex="0"
                                *ngIf="gethelpbutton && showOther"
                                (click)="onHotline($event)"
                                (keypress)="onHotline($event)"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve">
                                <svg-icon icon="get-help"></svg-icon>
                                <span translate>{{
                                    'contact.getHelpNow'
                                }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="app-l-result__card-body">
                        <div
                            class="app-l-result-item__base"
                            *ngIf="assessmentsList">
                            <div
                                class="app-l-result-item__card-block"
                                *ngFor="
                                    let assessment of assessmentsList;
                                    let i = index
                                ">
                                <div class="app-l-result-item__card-header">
                                    <div class="app-l-result-item__hl">
                                        <div class="app-l-result-item__icon">
                                            <svg-icon
                                                icon="calendar"
                                                class="w-100 h-100"></svg-icon>
                                        </div>
                                        <h3 class="app-c-body-text--14-m">
                                            {{
                                                assessment.created
                                                    | date: 'MM-dd-yyyy'
                                            }}
                                        </h3>
                                        <span class="app-l-result-item__time"
                                            >({{
                                                assessment.created
                                                    | date: 'h:mm a'
                                            }})</span
                                        >
                                    </div>
                                    <div class="app-l-result-item__hr">
                                        <button
                                            tabindex="0"
                                            *ngIf="
                                                loggedInUser.userType ===
                                                    'user' ||
                                                (loggedInUser.userType !=
                                                    'user' &&
                                                    !syncUserId)
                                            "
                                            class="app-c-btn app-c-btn--secondary app-c-btn--icon-border app-c-btn--icon-20"
                                            [routerLink]="[
                                                '/app/assessment/result',
                                                assessment.id,
                                                typeAssessment,
                                            ]"
                                            [queryParams]="{
                                                prevpage: 'listing',
                                            }">
                                            <svg-icon
                                                icon="angle-right"
                                                class="w-100 h-100"></svg-icon>
                                        </button>
                                        <button
                                            tabindex="0"
                                            *ngIf="
                                                loggedInUser.userType !=
                                                    'user' && syncUserId
                                            "
                                            class="app-c-btn app-c-btn--secondary app-c-btn--icon-border app-c-btn--icon-20"
                                            [routerLink]="[
                                                '/app/assessment/result',
                                                assessment.id,
                                                typeAssessment,
                                                syncUserId,
                                            ]"
                                            [queryParams]="{
                                                prevpage: 'adminlisting',
                                            }">
                                            <svg-icon
                                                icon="angle-right"
                                                class="w-100 h-100"></svg-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="app-l-result-item__card-body">
                                    <div
                                        class="app-l-rs__item-base"
                                        *ngIf="typeAssessment === 'dass'">
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                das.tableHeaders.0
                                            </h6>
                                            <p class="app-l-rs__status">
                                                {{
                                                    assessment.depressionlevellabel
                                                }}
                                            </p>
                                            <ng-container
                                                [ngTemplateOutlet]="
                                                    daslevelIndicationImg
                                                "
                                                [ngTemplateOutletContext]="{
                                                    level: assessment.depressionlevel,
                                                }">
                                            </ng-container>
                                            <button
                                                tabindex="0"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                *ngIf="
                                                    assessment.depressionlevel <
                                                    1
                                                "
                                                routerLink="/app/series-listing/purpose/130"
                                                translate>
                                                {{
                                                    'theory.courses.purpose.title'
                                                        | translate
                                                        | slice: 0 : 17
                                                }}...
                                            </button>
                                            <button
                                                tabindex="0"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                *ngIf="
                                                    assessment.depressionlevel ==
                                                        1 ||
                                                    assessment.depressionlevel ==
                                                        2 ||
                                                    assessment.depressionlevel ==
                                                        3 ||
                                                    assessment.depressionlevel ==
                                                        4
                                                "
                                                routerLink="/app/series-listing/depression_new/133">
                                                {{
                                                    'theory.courses.depression_new.title'
                                                        | translate
                                                        | slice: 0 : 17
                                                }}...
                                            </button>
                                        </div>
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                das.tableHeaders.1
                                            </h6>
                                            <p class="app-l-rs__status">
                                                {{
                                                    assessment.anxietylevellabel
                                                }}
                                            </p>
                                            <ng-container
                                                [ngTemplateOutlet]="
                                                    daslevelIndicationImg
                                                "
                                                [ngTemplateOutletContext]="{
                                                    level: assessment.anxietylevel,
                                                }">
                                            </ng-container>
                                            <button
                                                tabindex="0"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                *ngIf="
                                                    assessment.anxietylevel < 1
                                                "
                                                routerLink="/app/series-listing/sleep/127">
                                                {{
                                                    'theory.courses.sleep.title'
                                                        | translate
                                                        | slice: 0 : 17
                                                }}...
                                            </button>

                                            <span
                                                *ngIf="
                                                    !assessment.anxietylevel ==
                                                    0
                                                ">
                                                <button
                                                    tabindex="0"
                                                    class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                    *ngIf="
                                                        assessment.anxietylevel ==
                                                            1 ||
                                                        assessment.anxietylevel ==
                                                            2 ||
                                                        assessment.anxietylevel ==
                                                            3 ||
                                                        assessment.anxietylevel ==
                                                            4 ||
                                                        assessment.stresslevel ==
                                                            2 ||
                                                        assessment.stresslevel ==
                                                            3 ||
                                                        assessment.stresslevel ==
                                                            4
                                                    "
                                                    routerLink="/app/series-listing/anxiety/132">
                                                    {{
                                                        'theory.courses.anxiety.title'
                                                            | translate
                                                            | slice: 0 : 17
                                                    }}...
                                                </button>
                                            </span>
                                        </div>
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                das.tableHeaders.2
                                            </h6>
                                            <p class="app-l-rs__status">
                                                {{
                                                    assessment.stresslevellabel
                                                }}
                                            </p>
                                            <ng-container
                                                [ngTemplateOutlet]="
                                                    daslevelIndicationImg
                                                "
                                                [ngTemplateOutletContext]="{
                                                    level: assessment.stresslevel,
                                                }">
                                            </ng-container>
                                            <button
                                                tabindex="0"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                *ngIf="
                                                    assessment.stresslevel < 1
                                                "
                                                routerLink="/app/series-listing/mindfulness/128">
                                                {{
                                                    'theory.courses.mindfulness.title'
                                                        | translate
                                                        | slice: 0 : 17
                                                }}...
                                            </button>

                                            <button
                                                tabindex="0"
                                                class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                *ngIf="
                                                    assessment.stresslevel == 1
                                                "
                                                routerLink="/app/practice/zen-room">
                                                {{
                                                    'zenRoom.title'
                                                        | translate
                                                        | slice: 0 : 17
                                                }}
                                            </button>

                                            <span
                                                *ngIf="
                                                    assessment.stresslevel > 1
                                                ">
                                                <button
                                                    tabindex="0"
                                                    class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                    *ngIf="
                                                        assessment.stresslevel ==
                                                            2 ||
                                                        assessment.stresslevel ==
                                                            3 ||
                                                        assessment.stresslevel ==
                                                            4
                                                    "
                                                    routerLink="/app/series-listing/anxiety/132">
                                                    {{
                                                        'theory.courses.anxiety.title'
                                                            | translate
                                                            | slice: 0 : 17
                                                    }}...
                                                </button>
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        class="app-l-rs__item-base"
                                        *ngIf="typeAssessment != 'dass'">
                                        <div class="app-l-rs__item-block">
                                            <h6
                                                class="app-l-rs__title"
                                                translate>
                                                {{
                                                    assessmentTranslation[
                                                        typeAssessment
                                                    ]
                                                }}
                                            </h6>
                                            <div class="score-level">
                                                <p
                                                    *ngIf="
                                                        typeAssessment ==
                                                        'mentalwellbeing'
                                                    ">
                                                    {{
                                                        'dynamicAssessment.score'
                                                            | translate
                                                    }}{{
                                                        getMetricScore(
                                                            assessment
                                                        )
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        typeAssessment ==
                                                        'mentalwellbeing'
                                                    "
                                                    class="strong"
                                                    translate>
                                                    |
                                                </p>
                                                <p class="app-l-rs__status">
                                                    {{
                                                        getLevel(
                                                            assessment.type,
                                                            typeAssessment ==
                                                                'mentalwellbeing'
                                                                ? assessment.metricScore
                                                                : assessment.resultScore
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                            <ng-container
                                                [ngTemplateOutlet]="
                                                    daslevelIndicationImg
                                                "
                                                [ngTemplateOutletContext]="{
                                                    level: assessmentService.getAssessmentScoreLevel(
                                                        assessment.type,
                                                        typeAssessment ==
                                                            'mentalwellbeing'
                                                            ? assessment.metricScore
                                                            : assessment.resultScore
                                                    ),
                                                }">
                                            </ng-container>
                                            <button
                                                class="app-c-btn app-c-btn--secondary app-c-btn--sm app-c-btn--curve"
                                                *ngIf="
                                                    getButtonLabel(
                                                        assessment.type,
                                                        assessment.resultScore
                                                    )
                                                "
                                                (click)="
                                                    getButtonLink(
                                                        assessment.type,
                                                        assessment.resultScore
                                                    )
                                                ">
                                                {{
                                                    getButtonLabel(
                                                        assessment.type,
                                                        assessment.resultScore
                                                    )
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="app-l-result-item__base"
                            *ngIf="assessmentsList?.length === 0">
                            <div class="app-l-result-item__card-block">
                                <div>
                                    <h3 translate class="nodata-title">
                                        clientList.noData
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template let-level="level" #daslevelIndicationImg>
    <div
        [ngClass]="
            ['resilience', 'mentalwellbeing'].includes(typeAssessment)
                ? 'app-c-welltrack__progress app-c-welltrack__progress-medium resilience-very-high'
                : 'app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__very-high'
        "
        *ngIf="level == 4">
        <div class="app-c-welltrack__progress-fill" style="width: 100%"></div>
    </div>
    <div
        class="app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__high"
        *ngIf="level == 3">
        <div class="app-c-welltrack__progress-fill" style="width: 80%"></div>
    </div>
    <div
        class="app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__moderate"
        *ngIf="level == 2">
        <div class="app-c-welltrack__progress-fill" style="width: 60%"></div>
    </div>
    <div
        class="app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__mild"
        *ngIf="level == 1">
        <div class="app-c-welltrack__progress-fill" style="width: 40%"></div>
    </div>
    <div
        [ngClass]="
            ['resilience', 'mentalwellbeing'].includes(typeAssessment)
                ? 'app-c-welltrack__progress app-c-welltrack__progress-medium resilience-good'
                : 'app-c-welltrack__progress app-c-welltrack__progress-medium app-l-status__good'
        "
        *ngIf="level == 0">
        <div class="app-c-welltrack__progress-fill" style="width: 20%"></div>
    </div>
</ng-template>
